import { ClockCircleOutlined, FileTextOutlined, EditOutlined } from '@ant-design/icons';
import InfiniteScrollList from '../../components/Forms/ListView/InfiniteScrollList';
import { constants } from '../../constants/common';
import moment from 'moment';

const Timeline = ({ type, id }) => {
    return (
        <div className="space-y-6 bg-white p-4 rounded-sm">
            <InfiniteScrollList
                apiUrl='/timeline'
                apiQuery={{
                    refType: type,
                    refId: id,
                    andOr: 'and'
                }}
                height={750}
                renderItem={(item, index, timelineData) => <div key={index} className="relative pl-12">
                    {/* Icon */}
                    <div className="absolute left-0 top-1 flex flex-col items-center">
                        <div className="bg-white border border-gray-300 rounded-full p-2 text-lg h-10 w-10 text-center">
                            <FileTextOutlined />
                        </div>
                        {index !== timelineData.length - 1 && (
                            <div className="w-px bg-gray-300 h-full mt-2" />
                        )}
                    </div>

                    {/* Date Label */}
                    {(index === 0 || moment(item.createdAt).isSame(moment(timelineData[index - 1].createdAt), 'day')) && (
                        <div className="mb-2 text-sm font-medium text-gray-600 bg-gray-100 p-2 rounded w-max">
                            {item.createdAt ? moment(item.createdAt).format('MMM DD, YYYY') : item.date}
                        </div>
                    )}

                    {/* Content */}
                    <div className="p-4">
                        <div className="text-xs text-gray-500 mb-1">{item.time}</div>
                        <div className="text-sm">
                            <div>{item.title || ''}</div>
                            {item.message && <div dangerouslySetInnerHTML={{ __html: item.message }} />}
                        </div>
                        <div className="text-xs text-gray-500 mt-2">
                            by {constants.GET_FULL_NAME(item.createdBy)} {moment(item.createdAt).format('LLL')}
                        </div>
                    </div>
                </div>
                }
            />
        </div>
    );
};

export default Timeline;
